module.exports = __webpack_public_path__ + "static/media/clue-9.589767f0.svg";